export default __webpack_public_path__ + "static/XOXO_BLUE-a1d37b11c5f8d44a0dd32a8a0d707134.png";